const formatDateForInput = (isoDate: string): string => {
  if (!isoDate) return '';
  const date = new Date(isoDate);
  if (isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getTodayAsYYYYMMDD = (): string => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const convertToISO = (dateString: string, isEndOfDay: boolean): string => {
  if (!dateString) return '';

  // Parse the date string as local date (YYYY-MM-DD format)
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);

  if (isNaN(date.getTime())) return '';

  if (isEndOfDay) {
    date.setHours(23, 59, 59, 999);
  } else {
    date.setHours(0, 0, 0, 0);
  }

  return date.toISOString();
};

const formatYYYYMMDDAsMMDDYYYY = (dateString: string): string => {
  const [year, month, day] = dateString.split('-');
  return `${month}/${day}/${year}`;
};

const formatDateRangeMMDDYYYY = (startDate: string, endDate: string): string =>
  `${formatYYYYMMDDAsMMDDYYYY(startDate)} - ${formatYYYYMMDDAsMMDDYYYY(
    endDate,
  )}`;

const validateDateRange = (fromDate: string, toDate: string): string => {
  if (!fromDate && !toDate) {
    return '';
  }
  const today = getTodayAsYYYYMMDD();
  const todayDate = new Date(today);
  todayDate.setHours(23, 59, 59, 999);

  let fromDateObj: Date | null = null;
  let toDateObj: Date | null = null;

  if (fromDate) {
    fromDateObj = new Date(fromDate);
    if (isNaN(fromDateObj.getTime())) {
      return 'Invalid date';
    }
    if (fromDateObj > todayDate) {
      return 'Beginning date cannot be after today';
    }
  }

  if (toDate) {
    toDateObj = new Date(toDate);
    if (isNaN(toDateObj.getTime())) {
      return 'Invalid date';
    }
    if (toDateObj > todayDate) {
      return 'Ending date cannot be after today';
    }
  }

  if (fromDateObj && toDateObj && fromDateObj > toDateObj) {
    return 'Beginning date cannot be after Ending date';
  }

  return '';
};

export {
  formatDateForInput,
  formatDateRangeMMDDYYYY,
  getTodayAsYYYYMMDD,
  convertToISO,
  validateDateRange,
};
